<template>
    <div class="hidden lg:block ">
        <div class="topbar-height shadow-md">
            <div class="flex justify-between max-full-hd">
                <div class="topbar-height flex items-center pl-6">
                    <div class="flex-shrink-0 cursor-pointer" @click="openMenu()">
                        <img src="../../../../../assets/menu_icon/Hamburger-menu.png">
                    </div>
                    <div class="flex-shrink-0 ml-6 cursor-pointer" @click="clickHome()">
                        <img class="logo-bk" src="../../../../../assets/logo/Logo.svg">
                    </div>
                    <div  v-if="isShowDelivery">
                        <DeliveryTopBar></DeliveryTopBar>
                    </div>
                </div>
                <DesktopRightMenu></DesktopRightMenu>
            </div>
        </div>
    </div>
</template>
<script>
import DesktopRightMenu from './DesktopRightMenu.vue';
import DeliveryTopBar from './DeliveryTopBar.vue';

export default {
    inject: ['SideMenuStore'],
    props: {
        isShowDelivery: { type: Boolean, default: true },
    },
    components: {
        DesktopRightMenu,
        DeliveryTopBar,
    },
    methods: {
        openMenu: function () {
            this.SideMenuStore.methods.openProfileBar();
            console.log('click open menu');
        },
        clickHome: function () {
            this.$router.push('/home');
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import '@/style/base/display.scss';
    .topbar-height {
        height: $topbar-height;
    }
    .logo-bk {
        height: $bk-logo-height;
    }
</style>
